import * as React from 'react';
import { connect } from 'formik';
import debounce from 'lodash.debounce';
import isEqual from 'react-fast-compare';

export class PersistProps {
  name;
  debounce;
  handler;
}

class FormikPersistStoreImpl extends React.Component {
  static defaultProps = {
    debounce: 300,
  };

  saveForm = debounce((data) => {
    this.props.handler(data.values)
  }, this.props.debounce);

  componentDidUpdate(prevProps) {
       //console.log('persist?')
    //   console.log(prevProps);
    //   console.log(this.props);
    if (!isEqual(prevProps.formik, this.props.formik)) {
      this.saveForm(this.props.formik);
    }
  }

  componentDidMount() {
  }

  render() {
    return null;
  }
}

export const FormikPersistStore = connect(FormikPersistStoreImpl);